import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderTemplate } from 'src/app/shared/models/order-template.model';

@Component({
  selector: 'app-order-template',
  templateUrl: './order-template.component.html',
  styleUrls: ['./order-template.component.scss']
})
export class OrderTemplateComponent implements OnInit {


  @Input() options: OrderTemplate[];
  @Input() selectedValue: OrderTemplate;
  @Output() selection = new EventEmitter();

  constructor() { }

  ngOnInit(): void {

  }

  onOrderTemplateSelection(event: any) {
    this.selectedValue = event.option;
    this.selection.emit(event.option);
  }

}

